var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('input',{ref:"wkFileInput",staticStyle:{"display":"none"},attrs:{"name":_vm.data.name,"multiple":_vm.data.multiple,"accept":_vm.data.accept,"type":"file"},on:{"change":_vm.handleChange}})}
var staticRenderFns = []

export { render, staticRenderFns }